module.exports = __webpack_public_path__ + "img/certif_014.0ebfb413.jpg";